import { DragIndicator } from '@mui/icons-material';
import { Typography } from '@mui/material';
import React from 'react';
import { docGeniusPalette } from 'styles/partials/colors';
import styles from './ContentElement.module.css';
import { useDrag } from 'react-dnd';
import { ElementType, PagePartType } from 'features/document/constants';
interface ContentElementProps {
  icon: JSX.Element;
  title: string;
  type: ElementType;
}
export function ContentElement({ icon, title, type }: ContentElementProps) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: PagePartType.Block,
    item: { type: PagePartType.Block, elementType: type },
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move',
      }}
      className={styles.contentElementContainer}
    >
      <DragIndicator className={styles.contentElementDragIcon} />
      <div className={styles.contentElementContentAlignment}>
        {icon ?? icon}
        <Typography
          color={docGeniusPalette.cardDndAccentblue}
          fontSize='16px'
          fontWeight='400'
          gutterBottom
          marginTop='10px'
          textAlign='center'
          variant='h4'
        >
          {title}
        </Typography>
      </div>
    </div>
  );
}
